// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";

export default function PrivacyPage() {
  return (
    <main>
      <section className="page-hero ground" data-en="PRIVACY">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>プライバシーポリシー</span>
          </nav>
          <h1 className="page-title">
            プライバシーポリシー<strong>Privacy Policy</strong>
          </h1>
        </div>
      </section>
      <section className="section pp-sec">
        <div className="container">
          <div className="pp-wrap">
            <p className="pp-lead">
              株式会社LEAPS（以下「当社」といいます）は、当社が取り扱う個人情報の保護の重要性を認識し、個人情報の保護に関する法律（個人情報保護法）その他関係法令を遵守するとともに、以下のプライバシーポリシー（以下「本ポリシー」といいます）に基づき、個人情報を適切に取り扱います。
            </p>
            <section className="pp-item" id="pp-1">
              <h2>
                <span className="pp-num">01</span>事業者情報
              </h2>
              <div className="pp-body">
                <dl>
                  <div>
                    <dt>事業者名</dt>
                    <dd>株式会社LEAPS</dd>
                  </div>
                  <div>
                    <dt>所在地</dt>
                    <dd>東京都千代田区神田神保町1-41</dd>
                  </div>
                  <div>
                    <dt>代表者</dt>
                    <dd>塩原 洋平</dd>
                  </div>
                </dl>
              </div>
            </section>
            <section className="pp-item" id="pp-2">
              <h2>
                <span className="pp-num">02</span>取得する個人情報
              </h2>
              <div className="pp-body">
                <p>
                  当社は、本サービスの提供にあたり、以下の情報を取得することがあります。
                </p>
                <ul>
                  <li>
                    氏名、会社名、メールアドレス、電話番号などのお問い合わせ・お申し込み情報
                  </li>
                  <li>無料診断等のフォームにご入力いただいた回答内容</li>
                  <li>
                    Cookie、アクセスログ、IPアドレス、閲覧履歴等の利用情報
                  </li>
                </ul>
              </div>
            </section>
            <section className="pp-item" id="pp-3">
              <h2>
                <span className="pp-num">03</span>利用目的
              </h2>
              <div className="pp-body">
                <p>
                  当社は、取得した個人情報を以下の目的の範囲内で利用します。
                </p>
                <ul>
                  <li>お問い合わせ・ご相談・資料請求への対応のため</li>
                  <li>
                    無料診断の結果提供、および関連するご提案・ご連絡のため
                  </li>
                  <li>当社サービスに関する情報提供・ご案内のため</li>
                  <li>サービスの改善、品質向上、統計・分析のため</li>
                  <li>上記利用目的に付随する業務のため</li>
                </ul>
              </div>
            </section>
            <section className="pp-item" id="pp-4">
              <h2>
                <span className="pp-num">04</span>個人情報の第三者提供
              </h2>
              <div className="pp-body">
                <p>
                  当社は、法令に基づく場合を除き、あらかじめご本人の同意を得ることなく、個人情報を第三者に提供することはありません。
                </p>
              </div>
            </section>
            <section className="pp-item" id="pp-5">
              <h2>
                <span className="pp-num">05</span>個人情報の取扱いの委託
              </h2>
              <div className="pp-body">
                <p>
                  当社は、利用目的の達成に必要な範囲において、個人情報の取扱いの全部または一部を外部の事業者に委託することがあります。この場合、当社は委託先に対して必要かつ適切な監督を行います。なお、当社はフォームの管理・顧客管理のためにHubSpot等の外部サービスを利用しており、これらのサービスを通じて入力情報が保管されることがあります。
                </p>
              </div>
            </section>
            <section className="pp-item" id="pp-6">
              <h2>
                <span className="pp-num">06</span>アクセス解析・Cookieについて
              </h2>
              <div className="pp-body">
                <p>
                  当社のウェブサイトでは、利用状況の把握やサービス改善のため、Google
                  Analytics等のアクセス解析ツールおよびCookieを利用することがあります。また、広告の配信効果の測定および広告の最適化のため、Meta社のMetaピクセルを利用しています。これらにより収集される情報には個人を特定する情報は含まれません。ブラウザの設定によりCookieの利用を拒否することができますが、その場合一部の機能がご利用いただけないことがあります。
                </p>
              </div>
            </section>
            <section className="pp-item" id="pp-7">
              <h2>
                <span className="pp-num">07</span>安全管理措置
              </h2>
              <div className="pp-body">
                <p>
                  当社は、取り扱う個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のために、必要かつ適切な措置を講じます。
                </p>
              </div>
            </section>
            <section className="pp-item" id="pp-8">
              <h2>
                <span className="pp-num">08</span>開示・訂正・利用停止等の請求
              </h2>
              <div className="pp-body">
                <p>
                  ご本人から、個人情報の開示、訂正、追加、削除、利用停止等のご請求があった場合には、ご本人であることを確認のうえ、法令に従い遅滞なく対応します。ご請求は下記のお問い合わせ窓口までご連絡ください。
                </p>
              </div>
            </section>
            <section className="pp-item" id="pp-9">
              <h2>
                <span className="pp-num">09</span>お問い合わせ窓口
              </h2>
              <div className="pp-body">
                <p>
                  本ポリシーに関するお問い合わせ、個人情報の取扱いに関するご請求は、以下までご連絡ください。
                </p>
                <dl>
                  <div>
                    <dt>窓口</dt>
                    <dd>株式会社LEAPS 個人情報保護管理担当</dd>
                  </div>
                  <div>
                    <dt>メール</dt>
                    <dd>
                      <a href="mailto:info@leaps-inc.com">info@leaps-inc.com</a>
                    </dd>
                  </div>
                </dl>
              </div>
            </section>
            <section className="pp-item" id="pp-10">
              <h2>
                <span className="pp-num">10</span>本ポリシーの改定
              </h2>
              <div className="pp-body">
                <p>
                  当社は、法令の変更やサービス内容の変更等に応じて、本ポリシーを改定することがあります。改定後の本ポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
                </p>
              </div>
            </section>
            <p className="pp-date">制定日：2026年6月19日</p>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
